import React, { useEffect, useState } from 'react'
import * as jnb from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useSelector } from 'react-redux';
import CommonPost from '../../../CommonUtils/CommonAxios/CommonPost';
import Sweetalert from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { ERROR_MSG, public_url } from '../../../CommonUtils/Validations/RegularExpAndVar';
import * as Yup from "yup";
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
export default function CessPaymentDetails() {

    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const location = useLocation()
    const est_reg_id = location?.state?.data?.est_reg_id
    useEffect(() => {
        Formik.setFieldValue("establishmentId", est_reg_id);
        getSetDataFunction();
        getPaymentFunction();
        getTransactionFunction();


    }, [])
    const empFormValidations =
        Yup.object().shape({
            payment: Yup.string().required(ERROR_MSG),
            furthercost: Yup.string().required(ERROR_MSG),
            cessamount: Yup.string().required(ERROR_MSG),
        })
    const Formik = useFormik({
        enableReinitialize: false,
        initialValues: {
            establishmentId: "",
            mobile: loginreducer?.mobile,
            coseofestablishment: "",
            payment: '',
            furthercost: '',
            cessamount: ' '
        },
        onSubmit: (values) => {
            console.log(values)
            CommonPost.cessPaymentDetails(values).then((res) => {
                if (res.data !== undefined && res.data.scode === '01') {
                    Sweetalert(res.data.sdesc, 'success')
                    getPaymentFunction()
                    getTransactionFunction()
                }
                else if (res.data.scode === '02') {
                    Sweetalert(res.data.sdesc, 'warning')
                }
            }).catch(() => {
                console.log("error")
            });
        },
        validationSchema: empFormValidations
    })
    const [showData, setData] = useState([])
    const getSetDataFunction = () => {
        let val = Formik?.values?.establishmentId || est_reg_id
        let villUrl = config.url.BOC_URL + public_url + "establishment-registration?reg_id=" + val;
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data?.status === true) {
                setData(response.data.est_reg)
                let amount = response.data.est_reg[0]?.est_cost_of_construction
                Formik.setFieldValue('coseofestablishment', amount)
            }
            else {
                setData([])
            }
        });

    };
    const [paymentStatusData, setpaymentStatusData] = useState()
    const [paymentStatus, setpaymentStatus] = useState()
    const getPaymentFunction = () => {
        let val = Formik?.values?.establishmentId || est_reg_id
        let villUrl = config.url.BOC_URL + "cess-payment-status?est_reg_id=" + val;
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                setpaymentStatusData(response.data.cess_payment[0])
                setpaymentStatus(response?.data?.cess_payment[0]?.cess_to_be_paid === 0 ? true : false)
            }
            else {
                setpaymentStatusData([])
            }
        });
    };
    const [transactionData, settransactionData] = useState()
    const getTransactionFunction = () => {
        let val = Formik?.values?.establishmentId || est_reg_id
        let villUrl = config.url.BOC_URL + "cess-payment-transactions?est_reg_id=" + val;
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                settransactionData(response.data.cess_payment_transactions)
            }
            else {
                settransactionData([])
            }
        });
    };
    function PaymentAmount(e) {
        let amount;
        if (e.target.value === "full") {
            amount = Formik?.values?.coseofestablishment
        }
        else if (e.target.value === "partial") {
            amount = Formik?.values?.furthercost
        }
        Formik.setFieldValue('cessamount', onepercent(amount))
    }
    function PartialAmount(e) {
        let amount = e.target.value
        Formik.setFieldValue('cessamount', onepercent(amount))
    }
    function onepercent(value) {
        const cessamount = Math.round(value / 100);
        return cessamount
    }

     function paymentPage(e) {
          
                  // alert("Test");
                  // return false;
              
                  axios.get("https://swapi.dev.nidhi.apcfss.in/boc/boc-public/test").then((response) => {
                      //console.log("The Payment Details", response?.data);
                      console.log(response?.data);
                      if (response?.data?.scode === "01" ) {
              
                          let resData = response?.data?.encrypted_string;
                          let merchantId =response?.data?.merchant_id;
                   
                          const form = document.createElement('form');
                          form.method = 'POST';
                          form.action = 
                           "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";
                                    //   "https://test.sbiepay.sbi/secure/AggregatorHostedListener";
                                      // "https://sbiepay.sbi/secure/AggregatorHostedListene";
                          const inputmerchantid = document.createElement('input');
                          inputmerchantid.type = 'hidden';
                          inputmerchantid.name = 'merchIdVal';
                          inputmerchantid.id = 'merchIdVal';
                          inputmerchantid.value = merchantId;
                          form.appendChild(inputmerchantid);
                  
                          const inputencryption = document.createElement('input');
                          inputencryption.type = 'hidden';
                          inputencryption.name = 'EncryptTrans';
                          inputencryption.id = 'EncryptTrans';
                          inputencryption.value = resData;
                          form.appendChild(inputencryption);
                  
                          document.body.appendChild(form);
                          console.log(form);
                          form.submit();
              
                      }
                      else {
              
                          Swal.fire({
                              title: "Error",
                              icon: "question",
                          });
                      }
                  });     
              }
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="CESS Payment Details" />
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <div className="form-card-jnb" >
                            <jnb.Row className="pt-0 mt-2">
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label> Establishment Id</label>
                                    </jnb.InputGroup>
                                    <Field type="number" className="form-control" name="establishmentId" />
                                    <ErrorMessage name="establishmentId" component="div" className="text-error" />
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mt-4">
                                    <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                        getSetDataFunction();
                                        getPaymentFunction();
                                        getTransactionFunction()
                                    }}>Get Details</button>
                                </jnb.Col>
                            </jnb.Row>
                            {showData?.length > 0 && (
                                <>
                                    <div className="table-responsive" >
                                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                            style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                        >
                                            <thead>
                                                <tr>

                                                    <td colSpan={3} style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ebf6f7" }}>
                                                        Name of the Establishment - &nbsp;
                                                        <label>{showData[0]?.establishment_name} (  {showData[0]?.est_reg_id})</label>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <React.Fragment>
                                                    <tr>
                                                        <td><label>Location Details:</label></td>
                                                        <td><label>Addresss Details:</label></td>
                                                        <td><label>Manager Details:</label></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {showData[0]?.postal_address}, Door No-{showData[0]?.postal_door_no} ,
                                                            {showData[0]?.postal_village_name},
                                                            {showData[0]?.postal_mandal_name} ,
                                                            {showData[0]?.postal_district_name} dist.,
                                                            {showData[0]?.postal_pincode}
                                                        </td>
                                                        <td>
                                                            {showData[0]?.permanent_address}, Door No-{showData[0]?.permanent_door_no} ,
                                                            {showData[0]?.permanent_village_name},
                                                            {showData[0]?.permanent_mandal_name} ,
                                                            {showData[0]?.permanent_district_name} dist.,
                                                            {showData[0]?.permanent_pincode}
                                                        </td>
                                                        <td>
                                                            Name : &nbsp;{showData[0]?.manager_name}, <br />
                                                            {showData[0]?.manager_mobile},{showData[0]?.manager_email},
                                                            <br />
                                                            Address :  {showData[0]?.manager_address}, Door No-{showData[0]?.manager_door_no} ,
                                                            {showData[0]?.manager_village_name},
                                                            {showData[0]?.manager_mandal_name} ,
                                                            {showData[0]?.manager_district_name} dist.,
                                                            {showData[0]?.manager_pincode}
                                                        </td>

                                                    </tr>

                                                </React.Fragment>
                                            </tbody>

                                        </table>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1 style={{ fontSize: "18px" }}>Payment Status</h1>
                                        </div>
                                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                            style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                                            <thead>


                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th colSpan={3}>Estimated Cost Of Construction</th>
                                                    <th colSpan={3}>Cess Amount (1 % of Estimated Cost) </th>
                                                </tr>
                                                <tr>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>To Be Paid</th>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>To Be Paid</th>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.est_cost_of_construction}</td>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.further_cost_paid}</td>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.further_cost_to_be_paid}</td>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.tot_cess}</td>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.cess_paid}</td>
                                                    <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.cess_to_be_paid}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {transactionData?.length > 0 ? <>
                                            <div className="inner-herbpage-service-title-sub">
                                                <h1 style={{ fontSize: "18px" }}>Transaction Data</h1>
                                            </div>
                                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                                                <thead>
                                                    <tr>
                                                        <th>Cost for Construction</th>
                                                        <th>Cess Amount</th>
                                                        <th>Payment Type</th>
                                                        <th>Pyament Status</th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    {transactionData?.map((data, index) => {
                                                        return (
                                                            <tr key={index} id={index}>
                                                                <td >{data?.further_cost}</td>
                                                                <td >{data?.cess_amount}</td>
                                                                <td >{data?.payment_type}</td>
                                                                <td >{data?.payment_status}</td>

                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </> : ""}
                                    </div>

                                    {paymentStatus === false ? <> <jnb.Row className="pt-0 mt-2">
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1 style={{ fontSize: "18px" }}>Estimation of Establishment Details</h1>
                                        </div>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="">
                                                <label className=' w-100 mb-1'>Total Cost of establishment:</label>
                                                <Field type="number" name="coseofestablishment" className="form-control" readOnly />
                                                <ErrorMessage name="coseofestablishment" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="mt-1">
                                                <label>I'am paying:</label>
                                            </jnb.InputGroup>
                                            <div className="form-control">
                                                <Field type="radio" name="payment" value="full" onChange={(e) => { PaymentAmount(e) }} />&nbsp;Full&nbsp;
                                                <Field type="radio" name="payment" value="partial" onChange={(e) => { PaymentAmount(e) }} />&nbsp;Partial&emsp;&emsp;

                                            </div>
                                            <ErrorMessage name="payment" component="div" className="text-error" />
                                        </jnb.Col>
                                        {Formik.values.payment === "partial" && (
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                <jnb.InputGroup className="">
                                                    <label className=' w-100 mb-1'>paying for the cost of:</label>
                                                    <Field type="number" name="furthercost" className="form-control" onKeyUp={(e) => { PartialAmount(e) }} />
                                                    <ErrorMessage name="furthercost" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        )}


                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                            <jnb.InputGroup className="">
                                                <label className=' w-100 mb-1'>CESS Amount:</label>
                                                <Field type="number" name="cessamount" className="form-control" readOnly />
                                                <ErrorMessage name="cessamount" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>

                                    </jnb.Row>
                                        {/* <div className='text-end mt-0'>
                                            <button type="submit" className="btn btn-success btn-md">Submit</button>
                                        </div> */}

<div className="d-flex justify-content-center align-items-center mt-4 ">
  <jnb.Col xs={12} sm={8} md={6} lg={4} xl={3} xxl={2}>
    <button
      type="submit"
      className="btn btn-primary btn-sm rounded px-4"
       onClick={(e) => paymentPage(e)}
    // onClick={() => {
    //                  Formik.handleSubmit();
    //                 }}
    >
      Payment
    </button>
  </jnb.Col>
</div>
                                        </> : paymentStatus === false ? <h6 className="text-success fw-bold" style={{ textDecoration: "underline" }}>Payment Successfull</h6> : ""}

                                </>

                            )}



                        </div>

                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>
        </React.Fragment>

    )
}
